import { useState } from 'react'
import { LuX, LuCheck } from "react-icons/lu";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useUpdateReportDate } from '../../api/useReport';
import { SpinnerCustom } from './SpinnerCustom';

interface Props {
    id: string
    date: Date
}

export const SelectReportDate = ({ id, date = new Date() }: Props) => {

    const [newDate, setNewDate] = useState(date)
    const [activeModal, setActiveModal] = useState(false)
    const { mutate, isLoading } = useUpdateReportDate()

    const onSubmitDate = () => {

        if (date.getTime() === newDate.getTime()) {
            setActiveModal(false)
        }

        mutate({
            reportId: id,
            date: newDate
        }, {
            onSuccess: () => { setActiveModal(false) },
            onError: () => { setActiveModal(false) }
        })
    };

    return (

        <div>
            {
                activeModal
                    ?
                    <div className='flex'>
                        <div className='flex date-input-bg'>
                            <DatePicker
                                className="date-edit"
                                // showTimeSelect
                                dateFormat="dd / MM / yyyy"
                                selected={newDate}
                                onChange={(date: Date) => setNewDate(date)}
                                placeholderText="Select a date"
                                disabled={isLoading}
                            />
                            <button className='flex px-05' disabled={isLoading} onClick={() => {
                                setActiveModal(false)
                                setNewDate(date)
                            }}>
                                <LuX />
                            </button>
                        </div>

                        <button
                            className='tw-bg-green-600 tw-rounded-[0.5rem] tw-ml-2 tw-items-center tw-h-9 tw-w-9 tw-flex tw-justify-center'
                            disabled={isLoading}
                            onClick={onSubmitDate}
                        >
                            {
                                isLoading
                                    ? <SpinnerCustom size='xs' color='white' />
                                    : <LuCheck color='white' />
                            }
                        </button>
                    </div>
                    :
                    <button onClick={() => setActiveModal(true)} className="text-muted">{dayjs(date).format('DD/MM/YYYY')} | {dayjs(date).format('HH:mm')}</button>
            }
        </div>

    )
}
